const version = "2.4.8"
export {version} //, commit}